import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { doScale } from "./actionEditorHelpers";
import { Heading1Base } from "../shared/Heading";
const Container = styled.div.withConfig({
  displayName: "ActionNodeHeader__Container",
  componentId: "sc-aomfcd-0"
})(["min-height:", ";"], props => doScale(36, props.scale));
const Header = styled(Heading1Base).withConfig({
  displayName: "ActionNodeHeader__Header",
  componentId: "sc-aomfcd-1"
})(["overflow-x:clip;text-overflow:ellipsis;padding-left:", ";padding-right:", ";max-width:", ";padding-top:", ";height:", ";"], props => doScale(2, props.scale), props => doScale(5, props.scale), props => doScale(140, props.scale), props => doScale(2, props.scale), props => doScale(19.5, props.scale));
const Description = styled.div.withConfig({
  displayName: "ActionNodeHeader__Description",
  componentId: "sc-aomfcd-2"
})(["overflow-x:clip;text-overflow:ellipsis;padding-left:", ";padding-right:", ";max-width:", ";white-space:", ";"], props => doScale(2, props.scale), props => doScale(2, props.scale), props => props.truncate ? doScale(140, props.scale) : "unset", props => props.truncate ? "nowrap" : "normal");
export const ActionNodeHeader = observer(({
  title,
  description,
  scale
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    scale: scale
  }, /*#__PURE__*/React.createElement(Header, {
    scale: scale
  }, title), description && /*#__PURE__*/React.createElement(Description, {
    scale: scale,
    truncate: true
  }, description));
});
export const ActionNodeDescription = observer(({
  description,
  scale
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    scale: scale
  }, description && /*#__PURE__*/React.createElement(Description, {
    scale: scale
  }, description));
});